<template>
<div class="chapter">
<div class="inner_page">
<section class="ident pagecopyright" epub:type="copyright-page" id="pagecopyright">
<p class="copyright"><em class="italic">InterVarsity Press, USA</em></p>
<p class="copyright"><em class="italic">P.O. Box 1400, Downers Grove, IL 60515, USA</em></p>
<p class="copyright"><em class="italic"></em><a class="www" href="http://www.ivpress.com" target="_blank"><em class="italic">ivpress.com</em></a></p>
<p class="copyright"><em class="italic"></em> <a class="www" href="mailto:email@ivpress.com"><em class="italic">email@ivpress.com</em></a></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">Inter-Varsity Press, England</em></p>
<p class="copyright"><em class="italic">36 Causton Street, London SW1P 4ST, England</em></p>
<p class="copyright"><a class="www" href="http://www.ivpbooks.com" target="_blank"><em class="italic">ivpbooks.com</em></a></p>
<p class="copyright"><a class="www" href="mailto:ivp@ivpbooks.com"><em class="italic">ivp@ivpbooks.com</em></a></p>
<p class="linespace"></p>
<p class="copyright">©<em class="italic">2022 by Jeannine K. Brown</em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">Jeannine K. Brown has asserted her right under the Copyright, Designs and Patents Act, 1988, to be
identified as Author of this work.</em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording or otherwise, without the prior permission of the publisher or the Copyright Licensing Agency.</em></p><p class="linespace"></p>
<p class="copyright"><em class="italic">InterVarsity Press</em><em class="italic"><sup>®</sup></em><em class="italic">, USA, is the book-publishing division of InterVarsity Christian Fellowship/USA</em><em class="italic"><sup>®</sup></em><em class="italic"> and a member movement of the International Fellowship of Evangelical Students. Website: </em><a class="www" href="http://www.intervarsity.org" target="_blank"><em class="italic">intervarsity.org</em></a><em class="italic">.</em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">Inter-Varsity Press, England, originated within the Inter-Varsity Fellowship, now the Universities and Colleges Christian Fellowship, a student movement connecting Christian Unions in universities and colleges throughout Great Britain, and a member movement of the International Fellowship of Evangelical Students. That historic association is maintained, and all senior IVP staff and committee members subscribe to the UCCF Basis of Faith. Website: </em><a class="www" href="http://www.uccf.org.uk" target="_blank"><em class="italic">www.uccf.org.uk</em></a><em class="italic">.</em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">Unless otherwise stated, Scripture quotations are from The Holy Bible, New International Version (Anglicized edition). Copyright © 1979, 1984, 2011 by Biblica. Used by permission of Hodder &amp; Stoughton Ltd, an Hachette UK company. All rights reserved. ‘NIV’ is a registered trademark of Biblica. UK trademark number 1448790.</em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">First published 2022</em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">USA ISBN 978-1-5140-0505-7 (digital)</em></p>
<p class="copyright"><em class="italic">USA ISBN 978-1-5140-0504-0 (print)</em></p>
<p class="linespace"></p>
<p class="copyright"><em class="italic">UK ISBN 978-1-78974-267-1 (digital)</em></p>
<p class="copyright"><em class="italic">UK ISBN 978-1-78974-266-4 (print)</em></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781789742671_EPUB4.vue?389a3a46